<template>
  <div class="index">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <el-row>
              <el-col>
                <el-form
                  ref="formData"
                  :model="formData"
                  label-width="100px">
                  <el-row>
                    <el-col :span="6">
                      <el-form-item
                        label="设定月份"
                        prop="time"
                        :rules="{ required: true, message: '请输入目标时间', trigger: 'blur' }">
                        <el-date-picker
                          v-model="formData.time"
                          type="month"
                          value-format="yyyy-MM"
                          placeholder="请选择月份"/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      单位：万元
                    </el-col>
                  </el-row>
                  <el-row
                    v-if="formData.list.length"
                    v-for="(item, index) in formData.list"
                    :key="index"
                  >
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-form-item label="部门">
                          <el-input
                            class="jm-input220"
                            disabled
                            v-model="item.department"/>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-row>
                          <el-form-item
                            label="目标业绩"
                            :prop="'list.' + index + '.money'"
                            :rules="[
                              { required: true, message: '请输入目标金额', trigger: 'blur' },
                              { max: 5, message: '最多输入五位数字', trigger: 'blur' }
                            ]"
                          >
                            <el-input
                              class="jm-input220"
                              type="number"
                              max="5"
                              clearable
                              v-model="item.money"
                              placeholder="请输入目标金额-数字"/>
                          </el-form-item>
                        </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item>
                        <el-button
                          type="primary"
                          @click="submitForm('formData')">完成</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
</style>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';

export default {
  data() {
    return {
      department: [],
      dList: ['芥末日本', '芥末英澳', '芥末美国', '前程日本'],
      formData: {
        list: [],
        time: ''
      }
    };
  },
  created() {
    this.$http._post({
      url: '/index/B_I_Department/department',
    }).then(({ data }) => {
      this.department = data.department;
      this.department.forEach((d) => {
        if (this.dList.indexOf(d.department) !== -1) {
          d.money = '';
          this.formData.list.push(d);
        }
      });
    });
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('报账业绩目标添加, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$http._post({
              url: '/index/B_I_Department/departmentAdd',
              data: this.formData,
            }).then(({ data }) => {
              if (typeof data === 'string') {
                this.$message.error(data);
              } else if (typeof data === 'object') {
                this.$message({
                  type: 'success',
                  message: '编辑成功!'
                });
                this.$router.go(-1);
              }
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消编辑'
            });
          });
        } else {
          this.$message.error('请按提示补全表单！');
          return false;
        }
      });
    },
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
  },
};
</script>
